(function PackageDestinations($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		var packagePages = ['/Packages/destinations', '/Packages/view'];

		Adzuki.onload(packagePages, function onload()
		{
			// Submit the package search form with the destination
			// as the only parameter.
			$('.destination-search').click(function onDestinationPackageClick(event)
			{
				var $form             = $(this).closest('form'),
				    $destinationInput = $(this).siblings('.destination-field');

				event.preventDefault();

				$destinationInput.attr('disabled', false);
				$form.submit();
			});
		}, false);
	});
}(jQuery, window.Adzuki || {}));
